import AppRoutes from "routes";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import LanguageContextProvider from "context/LanguageContext";
import i18n from "translations";

function App() {
  return (
    <div>
      <I18nextProvider i18n={i18n} defaultNS={"translation"}>
        <LanguageContextProvider>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </LanguageContextProvider>
      </I18nextProvider>
    </div>
  );
}

export default App;
